import { render, staticRenderFns } from "./DiplomacyRow.vue?vue&type=template&id=2b28e64a&scoped=true&"
import script from "./DiplomacyRow.vue?vue&type=script&lang=js&"
export * from "./DiplomacyRow.vue?vue&type=script&lang=js&"
import style0 from "./DiplomacyRow.vue?vue&type=style&index=0&id=2b28e64a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b28e64a",
  null
  
)

export default component.exports